// extracted by mini-css-extract-plugin
export default {"pageWrap":"Oc-z","fullWidth":"Pc-z","heading":"Qc-z","fullBleed":"Rc-z","hidden":"Sc-z"};